import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateUserFamily, fetchUserFamilyById } from "../../../service/UserFamilyApi";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../../components/shared";
import useCheckLoggedin from "../../../utils/useCheckLoggedin";
function FamilyUpdate() {
  useCheckLoggedin();
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyData, setFamilyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
    setValue,
    watch
  } = useForm({ mode: "all" });

  useEffect(() => {
    const fetchFamilyData = async () => {
      try {
        if (id) {
          const data = await fetchUserFamilyById(id);
          setFamilyData(data);
        }
      } catch (error) {
        setError("குடும்பத் தகவலை பெறுவதில் பிழை ஏற்பட்டது");
      }
    };

    fetchFamilyData(); // Call the async function inside useEffect
  }, [id]); // Only re-run if id changes

  // When family data is updated, extract family member Aadhar numbers
  useEffect(() => {
    if (familyData && familyData.family.familyMembers) {
      // Set form default values, ensure id and familyHeadAadhar are set correctly
      setValue("id", String(familyData.family.id));  // Ensure id is set as a string
      setValue("kootamName", familyData.family.kootamName);
      setValue("customGroup", familyData.family.customGroup || "");
      setValue("familyHeadAadhar", familyData.family.familyHeadAadhar);  // Set the familyHeadAadhar correctly
      setValue("familyName", familyData.family.familyName || "");
    }
  }, [familyData, setValue]);

  // Handle form submission (API update)
  const onSubmit = async (data) => {
    if (loading) {
      return;  // Prevent form submission if loading is true
    }

    setLoading(true);

    // Explicitly convert the `id` to string before sending to API
    const familyId = String(familyData.family.id);

    // Only update if something has changed
    if (
      data.kootamName !== familyData.family.kootamName ||
      data.customGroup !== familyData.family.customGroup ||
      data.familyName !== familyData.family.familyName ||
      data.familyHeadAadhar !== familyData.family.familyHeadAadhar
    ) {

      // Prepare the final data object to send to the API
      const payload = {
        ...data, // Spread the existing form data
      };


      try {
        const success = await updateUserFamily(payload, familyId);
        if (success) {
          navigate(`/user/family/view/${familyId}`);
        }
      } catch (error) {
        console.error("குடும்பத்தை புதுப்பிக்க இயலவில்லை:", error);
      } finally {
        setLoading(false);
      }
    }
  };


  if (!familyData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }
  return (
    <>
      <Navbar />
      <Helmet>
        <title>குடும்பத்தை புதுப்பிக்கவும்</title>
        <link rel="canonical" href={`/family/update/${id}`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h3>குடும்ப விவரங்களை திருத்து</h3>
            <br />
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <input
                type="hidden"
                {...register("id")} // Register the id field so it is included in the form data
                value={familyData.family.id}  // Set the value of the id field from the family data
              />
              <div className="details-card">
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய குடும்பத் தலைவர் ஆதார்:</strong></span>
                  <span className="detail-value">{familyData.family.familyHeadAadhar || ""}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய நிலை:</strong></span>
                  <span className="detail-value">{familyData.family.status || ""}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்பப் பெயர் தமிழில் கொடுங்கள் (தமிழில் கொடுங்கள்)</strong></span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="familyName"
                      {...register("familyName", {
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                    />
                  </div>
                  {errors.familyName && <div className="auth_error">❗ {errors.familyName.message}</div>}
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>கூட்டம்:</strong></span>
                  <div className="auth_element">
                    <select
                      id="kootamName"
                      {...register("kootamName", { required: "கூட்டம் தேர்வு செய்ய வேண்டும்" })}
                      className="auth_select"
                    >
                      <option value="">-- ஒரு கூட்டத்தைத் தேர்ந்தெடுக்கவும் --</option>
                      <option value="செம்பூத்தான்">செம்பூத்தான்</option>
                      <option value="மணியன்">மணியன்</option>
                      <option value="முத்தன்">முத்தன்</option>
                      <option value="பிற">பிற (கூட்டம்)</option>
                    </select>
                    {errors.kootamName && <div className="auth_error">❗ {errors.kootamName.message}</div>}

                    {/* Custom Group Dropdown */}
                    {watch("kootamName") === "பிற" && (
                      <div className="auth_element">
                        <label className="auth_label">பிற (கூட்டம் - தமிழில் கொடுங்கள்)</label>
                        <input
                          type="text"
                          id="customGroup"
                          placeholder="உங்கள் கூட்டத்தை உள்ளிடவும்"
                          {...register("customGroup", {
                            required: "பிற (கூட்டம்) தேவை",
                          })}
                          className="auth_input"
                        />

                        {errors.customGroup && <div className="auth_error">❗ {errors.customGroup.message}</div>}
                      </div>
                    )}

                  </div>
                </div>



                <button type="submit" disabled={!isValid || isSubmitting}
                  className={`auth_submit ${!isValid || isSubmitting ? "disabled_btn" : ""}`}
                >
                  {loading ? 'சமர்ப்பிக்கிறது...' : 'சமர்ப்பிக்கவும்'}
                </button>
                <br />
              </div>
            </form>
            <button onClick={() => navigate(`/user/family/view/${id}`)}>குடும்பத்தைப் பார்</button>
            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல்</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyUpdate;
